<template>
    <div class="col-md-12" style="margin-bottom: 50px;">
        <b-container style="">
        <div class="row mb-1">
        </div>
        <b-container>
        <div class="row mt-2" style="">
                    <div class="col-md-4 align-items-center d-flex justify-content-center" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3">
                            <b-row class="">
                            <b-col sm="3" style="text-align:right;" class="mt-1">  
                            <label style="font-weight:600; font-size:14px;">Show</label><br>
                            </b-col>
                            <b-col sm="4" class="align-items-center d-flex justify-content-left">
                            <b-form-select
                                    style="font-weight:600; font-size:14px; border-radius: unset; border:none;"
                                    class=" col-xl-7 ml-1"
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions">
                            </b-form-select>
                            </b-col>
                            <b-col sm="5">
                            </b-col>
                            </b-row>
                        </b-form-group>
                    </div>
                    <div class="col-md-4" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3">
                            <b-row class="">
                            <b-col sm="4" style="text-align:right" class="mt-1">
                            <label style="font-weight:600; font-size:14px;">Filter By</label><br>
                            </b-col>
                            <b-col sm="8" class="align-items-center d-flex justify-content-left" style="text-align:left;">
                            <b-form-select style="font-weight:600; border:none; font-size:14px; border-radius: unset;" v-model="filterBy" id="filterBySelect" :options="sortOptions" class=" col-xl-12"></b-form-select>
                            </b-col>
                            </b-row>
                        </b-form-group>
                    </div>
                     <div class="col-md-1" style="text-align:right; color:#565754; font-size:14px;">
                        <b-button class="mt-3" size="sm" @click="filterOutcomes" variant="outline-none" style="font-weight:600; font-size:18px;"><b-icon-search class="h1"></b-icon-search></b-button>
                    </div>
                    <div class="col-md-3" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3" style="text-align:left">
                            <b-form-input
                                    style="font-weight:600; font-size:14px; border-radius: unset; border:none;"
                                    v-on:keyup.enter="filterOutcomes"
                                    v-model="filterValue"
                                    type="search"
                                    id="filterInput"
                                    size="sm"
                                    class=""
                                    placeholder="Search by column selected"></b-form-input>
                        </b-form-group>
                    </div>
            </div>
        </b-container>
        <b-container>
        <div class="row mt-3">
            <b-table class="userTable" style="background-color:#F4F4F4;" hover bordered  show-empty stacked="md" :items="fetchData" :fields="fields"
                     :sort-by.sync="sortBy" ref="tableOutcomes"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection" :small="small" :per-page="perPage"
                     :filter="filter"
                     :filterIncludedFields="filterOn"
                     :current-page="currentPage">
            
                <template v-slot:cell(id)="data">
                     <span style="font-weight:600; font-size:17px;" v-html="data.item.id"/>
                </template>
                 <template v-slot:cell(name)="data">
                     <span style="font-weight:600; font-size:17px;" v-html="data.item.name"/>
                </template>
                <template v-slot:cell(email)="data">
                     <span style="font-weight:600; font-size:17px; word-break: break-word;" v-html="data.item.email"/>
                </template>
                <template v-slot:cell(isactive)="data">
                    <div v-bind:hidden="data.item.isactive != 1">
                        <span style="color: #00A5E5; font-weight:600; padding: 10px;">
                            OPEN
                        </span>

                        <button v-bind:id="'disallow-admin-' + data.item.id" @click="allowDisallow(data.item, data.index, data.item.id, 'admin', 'disallow')"  style="margin-left: 20px; font-weight:600; background-color:#989898; color:white; border-radius: unset;" class="btn btn-md">CLOSE</button>
                    </div>
                    <div v-bind:hidden="data.item.isactive == 1">
                        <span style="color: #1D1D1D; font-weight:600; padding: 10px;">
                            CLOSED
                        </span>

                        <button v-bind:id="'allow-admin-' + data.item.id" @click="allowDisallow(data.item, data.index, data.item.id, 'admin', 'allow')" style="margin-left: 20px; font-weight:600; background-color:#91C85F; color:#1D1D1D; border-radius: unset;" class="btn btn-md">OPEN</button>
                    </div>
                </template>
            </b-table>
        </div>
        </b-container>
        <b-container>

        <div v-bind:hidden="loadedData" id="loadingGif" style="text-align: center;">
            <img src="../assets/loading.gif" style="text-align: center; height: 100px;">
        </div>
        </b-container>
        <b-container>
        <div class="col-md-12 mt-3">
            <div class="row justify-content-center">
                <b-pagination size="md" :total-rows="totalItems" v-model="currentPage" :per-page="perPage"></b-pagination>
            </div>
        </div>
        </b-container>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'UserRoles',
        components: {},
        data() {
            return {
                loadedData: false,
                apiUrl: process.env.VUE_APP_API_PATH,
                items: [],
                filter: null,
                filterValue: '',
                filterBy: 'id',
                filterOn: [],
                isEditing: false,
                small: false,
                sortBy: 'id',
                sortDesc: false,
                sortDirection: 'asc',
                pageOptions: [5, 10, 15],
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        //sortable: true,
                        searchable: true,
                    },
                    {
                        key: 'period',
                        label: 'PERIOD',
                       // sortable: true,
                        searchable: true,
                    },
                    {
                        key: 'isactive',
                        label: 'STATUS',
                    },
                ],
                totalItems: 0,
                perPage: 10,
                currentPage: 1,
            }
        },
        mounted() {
            this.fetchData()
        },
        computed: {
            sortOptions() {
                // Create an options list from our fields
                return this.fields
                    .filter(f => f.searchable)
                    .map(f => {
                        return {text: f.label, value: f.key}
                    })
            },
        },
        methods: {
            allowDisallow(item, index, id, type, action) {
                let tempThis = this;
                let btn = document.getElementById(action + '-' + type + '-' + id);
                let prevtext = btn.innerText;
                btn.disabled = true;
                btn.innerText = 'Processing ...';

                let data = {
                    id: id,
                    action: action,
                    type: type,
                };

                let url = this.apiUrl;
                fetch(url + '/updatereportingperiod', {
                    method: 'post',
                    headers: {'Content-Type': 'application/json',
                        'Accept': 'application/json'},
                    body: JSON.stringify(data)
                })
                    .then((res) => {
                        if (!res.ok) {
                            throw new Error("HTTP status " + res.status);
                        }
                        return res.json();
                    })
                    .then(res => {
                        btn.disabled = false;

                        if(res['success']){
                            setTimeout(function () {
                                let newVal = (action === 'allow' ? 1 : 0);

                                if(type === 'admin') {
                                    item.isactive = newVal;
                                }

                                btn.innerText = prevtext;
                            }, 50);
                        }
                    }).catch(error => {
                        console.log(error);
                        btn.disabled = false;
                        btn.innerText = prevtext;
                    });
            },
            filterOutcomes() {
                this.currentPage = 1;
                this.loadedData = false;
                this.items = [];
                this.fetchData();
            },
            fetchData(ctx, callback) {
                let url = this.apiUrl;
                let sortD = this.sortDesc ? 'desc' : 'asc';
                fetch(url + '/getperiods?_page=' + `${this.currentPage}&_limit=${this.perPage}&_filterBy=${this.filterBy}&_sortBy=${this.sortBy}&_sortDirection=${sortD}&_filter=${this.filterValue}`)
                    .then(res => res.json())
                    .then(res => {
                        this.totalItems = res["totalItems"];
                        this.loadedData = true;
                        this.items = res['data'];
                        callback(this.items);
                    });
            }
        }
    }
</script>

<style>
.userTable thead {
   background-color: #6C6C6C!important;
   color: #FFFFFF;
   font-size: 17px;
}
.table-bordered th, .table-bordered td {
    border: 2px solid white;
}
.page-link {
    position: relative;
    display:grid;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #171717!important;
    background-color:#F4F4F4!important;
    border: 5px solid white!important;
}
.page-item.disabled .page-link {
    color: #6c757d!important;
    pointer-events: none;
    cursor: auto;
    background-color:#F4F4F4!important;
    border-color: white!important;
}
.page-item.active .page-link {
    z-index: 3;
    color: #0062FF!important;
    background-color: #82CAFA!important;
    border-color: white!important;
}
</style>